import Swatch from './Swatch'

export default Swatch
